import { StubPage } from "./stub-page";

export function SettingsPage() {
  return (
    <StubPage
      title="Settings"
      description="Placeholder settings route."
    />
  );
}
